module.exports = __webpack_public_path__ + "static/img/222.b26226f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/222.png
// module id = k73g
// module chunks = 8